import { useRouter } from 'next/router'

import { CookieStorage } from '@/core/utils/cookies'

type UsePersistentStateProps = Record<'id' | 'value', string>

export function usePersistentState({
  id: cookieName,
  value: cookieValue,
}: UsePersistentStateProps) {
  const { asPath } = useRouter()
  const cookie = CookieStorage.get(cookieName)
  const hasCookies = !!cookie && cookie === cookieValue

  const createPersistentState = () => {
    const expireDate = new Date()
    expireDate.setMonth(expireDate.getMonth() + 11)
    CookieStorage.set(cookieName, cookieValue, expireDate.toUTCString(), asPath)
  }

  const disablePersistentState = () => CookieStorage.delete(cookieName)

  return { state: hasCookies, createPersistentState, disablePersistentState }
}
